import React from 'react';
import RadioList from '../RadioList';
import { occurrencePriorities } from '../../../schemas/dispatch';
import { translate } from '../../../services/translate';
import { FieldValues, Path } from 'react-hook-form';

function PriorityList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    return <RadioList
        name={name}
        clearValue={null}
        items={occurrencePriorities.map(priority => ({ label: translate(priority), value: priority }))}
    />;
}

PriorityList.getCount = RadioList.getCount;

export default PriorityList;
